import { Injectable } from '@angular/core';
import { MatDialog ,MatDialogRef} from '@angular/material/dialog';
import {  MatSnackBar  } from '@angular/material/snack-bar';
import { EIPMessageBoxComponent } from 'eipmessage-box';
import { EIPToastAlertComponent } from 'eiptoast-alert';
import { StandardOutputModel } from '../ViewModel/StandardOutputModel';

const regDialogBox: MatDialogRef<any>[] = [];

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	public isDialogOpen: boolean = false;

	constructor(private dialog: MatDialog, private _snackBar: MatSnackBar) { }

	/**
	 * Show Popup Message box
	 * @param message Message to show
	 * @param messageType 'Success' | 'Warning' | 'Information' | 'Confirm' ( .then data => 'yes' || 'no')
	 */
	showPopup(message: string, messageType: 'Success' | 'Warning' | 'Information' | 'Confirm'):Promise<any> {
		if (this.isDialogOpen) return new Promise((x)=>{});

		this.isDialogOpen = true;

		return new Promise((resolve) => {
			const _message: string = message;
			const _messageType: string = messageType;
			const _dialog = this.dialog;
			//if (_dialog.open) 
			{
				const dialogRef = this.dialog.open(EIPMessageBoxComponent, {
					panelClass: 'eip-messagebox-popup',
					hasBackdrop: true, backdropClass: '',
					disableClose: true,
					data: { _message, _messageType }
				});
				dialogRef.afterClosed().subscribe((result: any) => {
					this.isDialogOpen = false;

					if (result) {
						switch (result) {
							case 'ok': {
								resolve('yes');
								break;
							}
							case 'cancel': {
								resolve('no');
								break;
							}
						}
					}
				});
			}
		});
	}

	/**
	 * Show Toast Message
	 * @param _message Message to show
	 * @param _messageType 'Success' | 'Warning' | 'Information' | 'Error'
	 * @param durationInSecs Optional. 3 secs as default 
	 */
	showToast(_message: string, _messageType: 'Success' | 'Warning' | 'Information' | 'Error', _durationInSecs?: number) {
		let _panelClass = "";

		switch (_messageType) {
			case "Success":
				_panelClass = 'eip-toast-message-success';
				break;
			case "Warning":
				_panelClass = 'eip-toast-message-warning';
				break;
			case "Error":
				_panelClass = 'eip-toast-message-error';
				break;
			case "Information":
				_panelClass = 'eip-toast-message-information';
				break;
			default:
				_panelClass = 'eip-toast-message-information';
				break;
		}

		this._snackBar.openFromComponent(EIPToastAlertComponent, {
			panelClass: _panelClass,
			// duration: (_durationInSecs ? _durationInSecs : 3) * 1000,
			duration: 2000,
			horizontalPosition: 'right',
			verticalPosition: 'bottom',
			data: { _message, _messageType }
		});
	}

	/**
	 * Common save API response handler
	 */
	handleResponse(data: StandardOutputModel|any) {
		if (data['successCode'] == 200) {
			this.showToast(data['successMessage'], 'Success');
		} else {
			this.showToast(data['successMessage'], 'Warning');
		}
	}

	/**
	 * Show Popup Message box
	 * @param error Message to show and severity
	 * @param okHandler Handler for Ok Event
	 * @param cancelHandler Handler for Cancel Event
	 */
	showPopupMessageBox(error: { messageSeverity: any; messageText: any; }, okHandler?: { (): void; (): void; (): void; } | undefined, cancelHandler?: { (): void; (): void; (): void; } | undefined) {
		const message: string = error.messageText;
		let title: string;
		let messageType: string;
		switch (error.messageSeverity) {
			case '0':
				{
					title = 'Error';
					messageType = 'Error';
					break;
				}
			case '1':
				{
					title = 'Success';
					messageType = 'Success';
					break;
				}
			case '2':
				{
					title = 'Warning';
					messageType = 'Warning';
					break;
				}
			case '3':
				{
					title = 'Information';
					messageType = 'Information';
					break;
				}
			case '4':
				{
					title = 'Confirm';
					messageType = 'Confirm';
					break;
				}
			default:
				{
					title = 'Error';
					messageType = 'Error';
					break;
				}
		}
		const dialog = this.dialog;
		if (dialog.open) {
			let dialogRef;
			for (const x of regDialogBox) {
				x.close();
				regDialogBox.shift();
			}

			dialogRef = dialog.open(EIPMessageBoxComponent, {
				panelClass: 'eip-messagebox-popup',
				disableClose: true,
				data: { _title: title, _message: message, _messageType: messageType }
			});
			regDialogBox.unshift(dialogRef);
			dialogRef.afterClosed().subscribe((result: any) => {
				if (result) {
					switch (result) {
						case 'ok': {
							okHandler();
							break;
						}
						case 'cancel': {
							cancelHandler();
							break;
						}
					}
				}
			});
		}
	}
}
